/* eslint-disable no-invalid-this */
const {
    EVENT_NAMES: {
        ORDER_DETAILS,
        ORDER_DETAILS: { CURBSIDE }
    },
    ASYNC_PAGE_LOAD,
    SOT_LINK_TRACKING_EVENT
} = require('analytics/constants');
const processEvent = require('analytics/processEvent');

class OrderConfirmationSOTBindings {
    static STORE_STATUSES = {
        OPEN: 'open',
        CLOSED: 'closed',
        UNAVAILABLE: 'unavailable'
    };

    static triggerSOTAsyncAnalytics = ({ eventType = ASYNC_PAGE_LOAD, ...data }) => {
        const eventData = {
            data: {
                ...data
            }
        };

        processEvent.process(eventType, eventData);
    };

    static triggerSOTAnalytics = ({ eventName, ...data }) => {
        const eventData = {
            data: {
                linkName: eventName,
                actionInfo: eventName,
                specificEventName: eventName,
                ...data
            }
        };

        processEvent.process(SOT_LINK_TRACKING_EVENT, eventData);
    };

    static cancelOrderModal = () => {
        const { CANCEL_ORDER_MODAL, REASONS } = ORDER_DETAILS;
        OrderConfirmationSOTBindings.triggerSOTAsyncAnalytics({
            pageType: CANCEL_ORDER_MODAL,
            pageTypeDetail: REASONS
        });
    };

    static curbsidePickupCheckInModal = ({ storeStatus, activeScreenIndex }) => {
        const {
            PICKUP, HOURS_CLOSED, HERE_FOR_CURBSIDE, VERIFICATION, DETAILS
        } = CURBSIDE;
        digitalData.page.category.pageType = CURBSIDE.CURBSIDE;
        digitalData.page.attributes.world = digitalData.page.attributes.world || 'n/a';

        const world = digitalData.page.attributes.world;
        const pageType = digitalData.page.category.pageType;
        let pageName = '';
        const data = {};

        switch (storeStatus) {
            case OrderConfirmationSOTBindings.STORE_STATUSES.CLOSED:
                digitalData.page.pageInfo.pageName = `${PICKUP} ${HOURS_CLOSED}`;

                break;
            case OrderConfirmationSOTBindings.STORE_STATUSES.OPEN:
                if (activeScreenIndex === 0) {
                    digitalData.page.pageInfo.pageName = PICKUP;

                    data.linkData = `${CURBSIDE.CURBSIDE}:${HERE_FOR_CURBSIDE}`;
                    data.pageTypeDetail = VERIFICATION;
                } else if (activeScreenIndex === 1) {
                    digitalData.page.pageInfo.pageName = DETAILS;
                    data.pageTypeDetail = DETAILS;
                }

                break;
            case OrderConfirmationSOTBindings.STORE_STATUSES.UNAVAILABLE:
                digitalData.page.pageInfo.pageName = CURBSIDE.ORDER_NOT_AVAILABLE;

                break;
            default:
                return;
        }

        pageName = digitalData.page.pageInfo.pageName;

        data.pageName = `${pageType}:${pageName}:${world}:*`;
        data.pageType = digitalData.page.category.pageType;
        data.pageDetail = digitalData.page.pageInfo.pageName;

        OrderConfirmationSOTBindings.triggerSOTAsyncAnalytics(data);
    };

    static curbsideModalSuccess = () => {
        const { SUCCESS } = CURBSIDE;
        digitalData.page.pageInfo.pageName = SUCCESS;
        const world = digitalData.page.attributes.world;
        const pageType = digitalData.page.category.pageType;

        OrderConfirmationSOTBindings.triggerSOTAsyncAnalytics({
            pageName: `${pageType}:${SUCCESS}:${world}:*`,
            pageType: CURBSIDE.CURBSIDE,
            pageTypeDetail: SUCCESS
        });
    };

    static hereForCurbsideClick = ({ orderId }) => {
        const { HERE_FOR_CURBSIDE_CLICK } = CURBSIDE;
        OrderConfirmationSOTBindings.triggerSOTAnalytics({
            eventName: HERE_FOR_CURBSIDE_CLICK,
            orderId
        });
    };
}

module.exports = OrderConfirmationSOTBindings;
